import isClient from 'Utils/environment';
import { useLogger } from 'AppShell/logger/LoggerProvider';
import { DeviceType } from 'AppShell/appshell_types/appshellMetaTypes';

/* For clientside use only. E.g.: with click handlers or useEffect. */
const useDeviceType = () => {
    const logger = useLogger();

    const getByUserAgent = (): DeviceType => {
        if (!isClient()) {
            logger.error('Client side use only!');
            return 'UNKNOWN';
        }

        const agent = navigator.userAgent;
        if (/Android/i.test(agent)) {
            return 'ANDROID';
        }
        if (/iPhone|iPad/i.test(agent)) {
            return 'IOS';
        }
        return 'UNKNOWN';
    };
    return { getByUserAgent };
};

export default useDeviceType;
